import { normalizeDateOnly } from '../../../shared/dateOnly.mjs'

const categoryKeys = new Set(['membership','dining','golf','spa','racquet','fitness','rooms','events','other'].map(k => `accounting.portalCategories.${k}`))
// Item keys originate in mapRecurringBillingItemToMemberPortalAccountItem. Summary
// categories lose that key during grouping; recover it only from keyed items in
// that exact bucket. Unkeyed/custom categories remain authored content.
export function accountCategoryLabel(value, items, t) {
  const candidates = value.category_label_key ? [value] : items.filter(item => item.category === value.category)
  const keys = new Set(candidates.map(item => item.category_label_key))
  const key = keys.size === 1 ? [...keys][0] : null
  return categoryKeys.has(key) ? t(key) : value.category
}
const statuses = new Set(['open','partially_paid','paid','cancelled','void','overdue','pending','refunded','partially_settled','reversed','posted','invoiced','settled','written_off'])
export function accountStatusLabel(status, t) {
  return statuses.has(status) ? t(`memberBilling.status_${status}`) : t('memberAccount.unknownStatus')
}
export function formatAccountPeriod(period, locale) {
  if (!period) return ''
  // Current statement periods are generated by parseRecurringBillingStatementPeriod,
  // with key YYYY-MM and calendar-date bounds. Never reinterpret arbitrary labels.
  if (/^\d{4}-\d{2}$/.test(period.key || '') && normalizeDateOnly(period.period_start)) {
    const date = new Date(`${period.period_start}T12:00:00Z`)
    if (Number.isFinite(date.getTime())) return new Intl.DateTimeFormat(locale, {month:'long',year:'numeric',timeZone:'UTC'}).format(date)
  }
  return period.label || ''
}
